import FittingStationStore from '../_flux/stores/fitting_station_store';
import TyreBySizeStore from '../_flux/stores/tyre_by_size_store';
import ConfiguratorAction from '../_flux/actions/configurator_actions';

window['__FluxActions'] = { ConfiguratorAction };
window['__FluxStores'] = { TyreBySizeStore, FittingStationStore };
